module.exports = __webpack_public_path__ + "static/media/screen-hackaton.c6624c8f.PNG";